import React from "react";
import { Link } from "react-router-dom";
import "../sass/Footer.scss";
import { isMobile } from "react-device-detect";
import { BsLinkedin } from "react-icons/bs";
import {BsTwitter} from "react-icons/bs";
const Footer = () => {
  return (
    <div className={`${!isMobile ? "Footer" : "FooterMob"}`}>
      <div>
        <img alt="Logo_Symbol_Dark Mode" src="/Logo_Symbol_Dark Mode.svg" /> 
        <a href="https://skyserve.ai/" target="_blank">
        <div className="logo-footer">
        
            <div>© 2024 SkyServe</div>
            
        </div>
        </a>
        <div style={{color:"gold"}}>All rights reserved</div>
      </div>
      <div className="icons-social">
        <a href="https://www.linkedin.com/company/skyserve-ai/mycompany/" target="_blank">
          <BsLinkedin style={{color:"rgb(10,102,194)"}} />
        </a>
        <a href="https://twitter.com/SkyServe_" target="_blank">
           <BsTwitter style={{color:"rgb(29,161,243)"}}/>
          </a>
         
        </div>
      <div className="policy">
        
        
        <a href='https://skyserve.ai/terms_of_use/' target="_blank">Terms of use</a>
        <a href='https://skyserve.ai/privacy_policy/' target='_blank'>Privacy Policy</a>
      </div>
    </div>
  );
};

export default Footer;
